import React, { useEffect, useRef, useState } from 'react'
import TopTitleBar from './TopTitleBar';
import NavLinks from '../../../components/NavLinks';
import Pagination from './Pagination';
import Records from './Records';
import API from '../../../ApiConfig'
import { BASE_URL, EXPORT_ISSUER_DOCUMENT_DATA, GET_ALL_COMPANIES, GET_ISSUED_DATA_COUNT, USER_TOKEN } from '../../../Utils/constant'
import { AuthConsole, convertDateFormat, Debounce, Delay, parseBlobError } from '../../../Utils/helper'
import Loader from '../../../components/Loader';
import cogoToast from 'cogo-toast-react-17-fix';
import useRefreshToken from '../../../Hooks/usegenerateToken';
import SlideUpWrapper from '../../../components/Transitions/SlideUpWrapper';
import FadeOutWrapper from '../../../components/Transitions/FadeOutWrapper';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import dropdownStyle from "../ExternalDash/Verifier/VerifyUsers.module.css";
import ShimmerLoader from '../../../components/ShimmerLoader';
import SearchDropdown from './Employment/searchDropdown';
import PageSizeSelector from '../../../Utils/PageSizeSelector';
export default function Credentials({ ISSUER_ID }) {
    useRefreshToken(BASE_URL + USER_TOKEN)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalItems, setTotalItems] = useState(0)
    const [search, setSearch] = useState('')
    const [MenuLinks, setMenuLinks] = useState([
        { name: "All Documents", link: "", subText: '0', pos: 0 },
        { name: "In Draft", link: "DRAFT", subText: '0', pos: 1 },
        { name: "Published", link: "PUBLISHED", subText: '0', pos: 2 },
        { name: "Revoked", link: "REVOKED", subText: '0', pos: 3 },
        // { name: "Change Requested", link: "change_requested", subText: '0', pos: 4 }
    ])
    
    const [pos, setPos] = useState(0)
    const location = useLocation();
    const [activeTab, setActiveTab] = useState({ name: "All Documents", link: "", subText: '0', pos: 0 })
    const [currentRecords, setCurrentRecords] = useState([])
    const [ischangeRequested, setisChangeRequested] = useState(location.state?.change_request || false)
    const [apiRecords, setApiRecords] = useState({})
    const [loading, setLoading] = useState(false);
    const [ListData, setListData] = useState([])
    const holder_data=localStorage.getItem("holder_data")
    const isSuperUser=useSelector(state => state.User)
    const[companiesList, setCompaniesList]=useState([])
    const[company, setCompany]=useState({

        "id": 0,
        "name": "Select Issuer",
        "issuers": [],
        "verifiers": []
    })
    const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" })
    const User=useSelector(state=>state.User)
    const [sortBy, setSortBy]=useState({
        key:"updated_at",
        direction:"desc"
    })
    function handleActiveTab(e) {
        setActiveTab(e)
    }
    const navigate=useNavigate()
    const[pageSize, setPageSize]=useState(10)
    useEffect(()=>{
        if(holder_data){
            localStorage.removeItem("holder_data")
        }
    },[])
    async function getIssuedData() {
        setLoading(true);
        // await Delay()
        API.get(`${GET_ISSUED_DATA_COUNT}${isSuperUser.user_type=="Super Admin"?`?issuer_company_id=${company.id|| ""}`:`?issuer_company_id=${User.company_id}`}`, {
            params: {
                issued_data_state: activeTab?.link,
                page: currentPage,

                sort_by:sortBy.key,
                search:search,
                sort_order:sortBy.direction, 
                per_page:pageSize
            }
        })
            .then(res => {
                if (res.data.status === 200) {
                    setLoading(false)
                    let { data } = res.data
                    let { data: { items }, data: { total_pages }, data: { total_items }, all_count, draft_count, published_count, revoked_count, change_requested, pending_requests, pending_appeals } = data
                    let allRecords = items
                    let tempLinks = [...MenuLinks]
                    tempLinks[0].subText = all_count
                    tempLinks[1].subText = draft_count
                    tempLinks[2].subText = published_count
                    tempLinks[3].subText = revoked_count
                    // tempLinks[4].subText = change_requested

                    // tempLinks[4].subText = pending_requests
                    // tempLinks[5].subText = pending_appeals
                    setMenuLinks(tempLinks)
                    setCurrentRecords(allRecords)
                    data.allRecords = allRecords
                    setApiRecords(data)
                    setTotalPages(total_pages)
                    setTotalItems(total_items)
                    setListData(allRecords);
                    // if (ischangeRequested)
                    //     setisChangeRequested(false)
                }
            })
            .catch(err => {
                setLoading(false)
                AuthConsole(err);
                cogoToast.warn("No issued Data")
            })
    }
    // console.log("Current Records:",currentRecords);
    function handleSearch(e) {
        setSearch(e)
        setCurrentPage(1)
    }
    
    useEffect(()=>{
        const handleSearchFilter = setTimeout(() => {
            getIssuedData()

    }, 500)
    return ()=>clearTimeout(handleSearchFilter)
},[search,activeTab, currentPage, sortBy, pageSize, company])

    useEffect(() => {
        setCurrentPage(1);
    }, [activeTab]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    }
    useEffect(()=>{
        if(isSuperUser.user_type=="Super Admin"){
            getAllCompanies_issuer()
        }

    },[])
    const getAllCompanies_issuer=()=>{
        setLoading(true)
        API.get(GET_ALL_COMPANIES+`?company_type=Issuer`)
        .then(res=>{
          if(res.data.status==200){
            setLoading(false)
            const issuerList=[...res?.data?.data?.filter(item=>item.id!==0)]
            setCompaniesList(issuerList)

          }          
        })
        .catch(err=>{
            setLoading(false)
            AuthConsole(err);
          
        })
      }
    const Dropdown = ({ listType, list, selectedOption, label, onSelect, type }) => {
                     const [isOpen, setIsOpen] = useState(false);
                     const dialogBox = useRef(null);
                     const handleToggle = () => {
                         setIsOpen(!isOpen);
                     };
             
                     useEffect(() => {
                         const handleClickOutside = (event) => {
                             if (dialogBox.current && !dialogBox.current.contains(event.target)) {
                                 setIsOpen(false);
                             }
                         };
                         document.addEventListener('click', handleClickOutside);
                         return () => {
                             document.removeEventListener('click', handleClickOutside);
                         };
                     }, []);
                     const handleSelectItem=(item)=>{
                      onSelect(item, type)
                      setIsOpen(false)
                     }
                     if (listType == 0) {
                         return (
                             <div className={dropdownStyle.letter} ref={dialogBox} style={{ width: '15rem', padding:"0px 15px" }}>
                                 <div className={dropdownStyle.lettertype} onClick={handleToggle} style={{ cursor: "pointer" }}>
                                     <div className={dropdownStyle.selectItem}>
             
                                         <p> {selectedOption?.name ? selectedOption.name : label}</p>
                                         {isOpen ? <img src='/chevrondown.svg' style={{ transform: "rotate(180deg)" }} /> : <img src='/chevrondown.svg' />}
                                     </div>
                                 </div>
                                 <div className={dropdownStyle.customDropdown} style={{ width: "inherit" }}>
                                     {isOpen && (
                                         <div className={dropdownStyle.dropdownOptions} style={{ maxHeight: '20rem', overflowY: 'scroll' }}>
                                             {list.map((i) => (
                                                 <div key={i.id} className={dropdownStyle.dropdownList} onClick={() => handleSelectItem(i)}>
                                                     {i.name}
                                                 </div>
                                             ))}
                                         </div>
                                     )}
                                 </div>
                             </div>
                         );
                     } 
                    }
    
    const handleSelect=(item)=>{
        setCompany(item)
        localStorage.setItem("issuer_id", item.id)
    }
    const handleIssueDocument=()=>{ 
        if(!company || company.issuers?.length==0){
            cogoToast.error("Select Issuer ")
        }
        else{
            navigate("/company/2/"+company.issuers[0]?.id+"/credentials/issue-credentials")
        }
    }
                    
    const handlePageSize=(newSize)=>{
        setPageSize(newSize)
        setCurrentPage(1)
      }
      const handleDateChange = (field, e) => {
        setDateRange((prev) => ({ ...prev, [field]: e }));
      }
      const handleDownload=(e)=>{
        e.preventDefault()
        setLoading(true);
          if (dateRange.startDate !== "" && dateRange.endDate !== "") {
            const status = activeTab?.link.toLowerCase()
            const params = {
              status,
              start_date: convertDateFormat(dateRange.startDate),
              end_date: convertDateFormat(dateRange.endDate),
            }
            // issuer_company_id is required only for super admin; for an issuer the
            // backend derives it from the JWT.
            if (isSuperUser.user_type == "Super Admin") {
              if (!company?.id) {
                setLoading(false)
                cogoToast.error("Please select an issuer company")
                return
              }
              params.issuer_company_id = company?.id
            }
    API.get(EXPORT_ISSUER_DOCUMENT_DATA, { params, responseType: "blob" })
        .then((res) => {
          if (res.status == 200) {
            setDateRange({ startDate: "", endDate: "" });
            getIssuedData()
            const blob = new Blob([res.data], {
            //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");

            link.href = url;
            link.download = `Documents_${status}_${dateRange.startDate}_to_${dateRange.endDate}.xlsx`;
            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(url)
  }
            }
            )
            .catch(async (err) => {
                      cogoToast.error(await parseBlobError(err));
                    })
                    .finally(() => {
                      setLoading(false);
                    });
                } else {
                  setLoading(false);
                  cogoToast.error("Enter Valid Start and End Date");
                }
      }
    
    return (
        <div style={{width:"100%"}}>
            <SlideUpWrapper>
                <TopTitleBar isChild ><h2 className="topTitleBarText"><span className='secondaryButton1'>Documents</span></h2></TopTitleBar>
                <div>
                    <div className="navLinksContainer" style={{display:"flex", flexDirection:"row"}}>
                        <div>
                        <NavLinks loading={loading} MenuLinks={MenuLinks} menuClick={handleActiveTab} />
                        </div>
                        {(activeTab?.link === "DRAFT" || activeTab?.link === "PUBLISHED") &&
                        <div>
                            <input
                                                          type="date"
                                                          className="datePicker"
                                                          value={dateRange.startDate}
                                                          style={{ margin: "0px 25px" }}
                                                          onChange={(e) => {handleDateChange("startDate", e.target.value);setCurrentPage(1)}}
                                                        />
                                                        <input
                                                          type="date"
                                                          className="datePicker"
                                                          value={dateRange.endDate}
                                                          onChange={(e) => {handleDateChange("endDate", e.target.value);setCurrentPage(1)}}
                                                        />
                        <button className='btn btn-primary' onClick={(e)=>handleDownload(e)}>Export</button>
                        </div>}
                    {User.user_type=="Super Admin" &&    <div style={{display:"flex"}}>
                            <div>
                            {/* <Dropdown
                                listType={0}
                                list={companiesList}
                                selectedOption={company}
                                label={"Choose Issuer"}
                                type={"Issuer"}
                                onSelect={handleSelect}
                            /> */}
                            <SearchDropdown apidata={companiesList} value={company} displayKey="name" placeholder='Select Issuer...' onSelect={(e)=>{setCompany(e)}} width='12rem'/>
                            </div>
                            <div>
                            <button className={`${!company ||company?.issuers?.length==0?"btn btn-secondary":"btn btn-primary"}`} style={{margin:"10px 0px"}} onClick={()=>handleIssueDocument()}>Issue Document</button>
                            </div>
                        </div>}
                    </div>
                    <section className="table-header6">
                        <div className="inputField2">
                            <div className="input1">
                                <div className="content1">
                                    <img className="searchOutlineIcon1" alt="" src="/searchoutline.svg" />
                                    <input value={search} onChange={e => handleSearch(e.target.value)} className="inputText1" placeholder="Search" />
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="credentials-table">
                        {/* <Loader isOpen={loading}/> */}
                        <Records loading={loading} IssuerData={currentRecords} refreshList={getIssuedData} sortBy={sortBy} onSortChange={setSortBy} activeTab={activeTab} />
                    </div>
                    <div style={{ margin: "10px" }}>
                        <PageSizeSelector value={pageSize} onChange={handlePageSize} total_items={totalItems}/>
                        <Pagination
                            nPages={totalPages}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            onPageChange={handlePageChange}
                            loading={loading}
                        />
                    </div>
                </div>
            </SlideUpWrapper>

        </div>
    )
}
